import type { OrderDetailType, ProductType } from 'types/assembly/model'

const mockProduct: ProductType = {
  containerId: 'AB-LPN-0000000P',
  productZone: 'Abarrotes',
  imgUrl: 'https://picsum.photos/200/300',
  name: 'Coca cola 600ml',
  barcode: '123456789',
  sku: '12345',
  quantity: 120,
  processedQuantity: [120],
  unitsOfMeasurment: 1,
  measureUnit: 'pcz',
  isStockOut: false
}

export const mockData: OrderDetailType = {
  toWarehouse: 'DF0004G',
  transferId: '123',
  containers: [
    {
      id: 'AB-LPN-0000000P',
      products: [mockProduct],
      totalSKUs: 8,
      location: 'ARMADO-1'
    },
    {
      id: 'AB-LPN-0000000Q',
      products: [mockProduct],
      totalSKUs: 2,
      location: 'ARMADO-1'
    },
    {
      id: 'AB-LPN-0000000R',
      products: [],
      totalSKUs: 1,
      location: 'ARMADO-1'
    },
    {
      id: 'AB-LPN-0000000S',
      products: [mockProduct],
      totalSKUs: 1,
      location: 'ARMADO-1'
    }
  ]
}
